<div class="card">
  <div class="card-header">
    <h1>Empresas Asociadas (Administrativas - Fiscales)</h1>
  </div>
  <div class="card-body">
    <span class="text-muted">
      <i class="fa fa-circle-info"></i>
      Para asociar una empresa administrativa a una fiscal, conecta los círculos 
      <i class="fa-regular fa-circle"></i> y luego presiona guardar.
    </span>

    <div class="row">
      <svg id="svg-container" #svgContainer></svg>
        <!-- Tabla de empresas administrativas -->
        <div class="col">
        <div class="form-group">
            <label for="searchAdministrative" class="form-label">Buscar empresa administrativa</label>
            <input type="text" [(ngModel)]="filterAdministrative" (input)="writeAdministrative()" 
                class="form-control" placeholder="Nombre de empresa administrativa" />
        </div>

        <div class="table-responsive mt-3">
            <table class="table table-bordered" id="table-administrative">
            <thead>
                <tr class="tr-middle">
                <th></th>
                <th>NIT</th>
                <th>Nombre</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let admin of administrativeCompanies"
                    [attr.data-id]="admin.id"
                    (click)="selectRow('administrative', admin.id)"
                    [class.selected]="admin.id === administrativeId">
                <td>
                    <i [ngClass]="admin.id === administrativeId ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                </td>
                <td>{{ admin.nit }}</td>
                <td>{{ admin.name }}</td>
                </tr>
                <tr *ngIf="administrativeCompanies.length === 0">
                <td colspan="3" class="text-muted">
                    <i class="fa fa-circle-info"></i> No se encontraron empresas administrativas.
                </td>
                </tr>
            </tbody>
            </table>
        </div>

        <!-- Paginación administrativa -->
        <app-simple-pagination
            id="administrative-pag"
            [sizes]="[5, 10, 20]"
            (changed)="administrativeId = null; refreshAdministrativePagination()"
            [elements]="paginationAdministrative">
        </app-simple-pagination>
        </div>

        <!-- Tabla de empresas fiscales -->
        <div class="col">
        <div class="form-group">
            <label for="searchFiscal" class="form-label">Buscar empresa fiscal</label>
            <input type="text" [(ngModel)]="filterFiscal" (input)="writeFiscal()" 
                class="form-control" placeholder="Nombre de empresa fiscal" />
        </div>

        <div class="table-responsive mt-3">
            <table class="table table-bordered" id="table-fiscal">
            <thead>
                <tr class="tr-middle">
                <th></th>
                <th>NIT</th>
                <th>Nombre</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let fiscal of fiscalCompanies"
                    [attr.data-id]="fiscal.id || fiscal.companyId"
                    (click)="toggleFiscalRelation(fiscal.id || fiscal.companyId)"
                    [class.selected]="currentRelatedIds.includes(fiscal.id || fiscal.companyId)">
                <td>
                    <i [ngClass]="currentRelatedIds.includes(fiscal.id || fiscal.companyId) ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                </td>
                <td>{{ fiscal.nit != null ? fiscal.nit : fiscal.companyNIT }}</td>
                <td>{{ fiscal.name != null ? fiscal.name : fiscal.companyName }}</td>
                </tr>
                <tr *ngIf="fiscalCompanies.length === 0">
                <td colspan="3" class="text-muted">
                    <i class="fa fa-circle-info"></i> No se encontraron empresas fiscales.
                </td>
                </tr>
            </tbody>
            </table>
        </div>

        <!-- Paginación fiscal -->
        <app-simple-pagination
            id="fiscal-pag"
            [sizes]="[5, 10, 20]"
            (changed)="fiscalId = null; refreshFiscalPagination()"
            [elements]="paginationFiscal">
        </app-simple-pagination>
        </div>
    </div>

    <div class="text-center mt-4">
      <app-loading-button [disabled]="!selectedAdministrativeId" [object]="buttonAssociate"
                    (clicked)="saveAssociations()"></app-loading-button>
    </div>
  </div>
</div>
